import { useCallback, useEffect, useState } from 'react';
import { useKeycloak } from '../../authentication/keycloak/KeycloakProvider';
import { listFacilityDisplays } from '../services/facility-display.service';
import type FacilityDisplay from '../models/facility-display';

interface UseFacilityDisplaysResult {
  displays: FacilityDisplay[];
  isLoading: boolean;
  refresh: () => Promise<void>;
}

export const useFacilityDisplays = (facilityId: string): UseFacilityDisplaysResult => {
  const keycloak = useKeycloak();
  const [displays, setDisplays] = useState<FacilityDisplay[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const refresh = useCallback(async (): Promise<void> => {
    const result = await listFacilityDisplays(facilityId, keycloak);
    setDisplays(result ?? []);
    setIsLoading(false);
  }, [facilityId, keycloak]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { displays, isLoading, refresh };
};

export default useFacilityDisplays;
